import { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import axios from "axios";
import AppConst from "../apis/appconst";
import NewSupplier from "../models/NewSupplier";
import AddMedicine from "../models/AddMedicine";

const C = {
    bg:"#f8f9fc",gridHdr:"#eef1f7",gridHdrText:"#3b4a6b",
    gridBorder:"#e2e6ef",rowEven:"#ffffff",rowOdd:"#f5f7fb",rowActive:"#e8edff",
    cellText:"#2d3748",accent:"#0d6efd",accentGlow:"rgba(13,110,253,0.15)",
    statusText:"#6b7a99",warnText:"#b45309",green:"#16a34a",red:"#dc2626",
    inputBg:"#ffffff",inputBorder:"#d1d5e4",inputFocus:"#0d6efd",titleBg:"#0d6efd",
};

const EDIT_COLS=['purchase_item_qty','purchase_item_tab_cap','purchase_item_free','purchase_item_batch','purchase_item_expiry_month','purchase_item_expiry_year','purchase_item_pur_price','purchase_item_mrp','purchase_item_discount','purchase_item_gst'];
const PER_PAGE=10;

function ERPPurchaseView({
    formData,setFormData,handleChange,handleChange1,handleDeleteItem,
    handleSubmit,ldata,onSwitchToNormal,
    supplierOptions,medicineOptions,selectedMedicine,setSelectedMedicine,
    isMedicineMenuOpen,setIsMedicineMenuOpen,medicineSelectRef,
    handleAddDepart,handleAddMedicine,
}) {
    const erpRef=useRef(null);
    const wantFS=useRef(true);
    const invoiceRef=useRef(null);
    const dateRef=useRef(null);
    const challanRef=useRef(null);
    const medSearchInputRef=useRef(null);
    const otherChargesRef=useRef(null);
    const discountRef=useRef(null);
    const noteRef=useRef(null);
    const rowRefs=useRef([]);
    const supplierInputRef=useRef(null);

    const [currentTime,setCurrentTime]=useState('');
    const [erpActiveRow,setErpActiveRow]=useState(null);
    const [erpActiveCol,setErpActiveCol]=useState(null);

    // Supplier dropdown
    const [supplierSearch,setSupplierSearch]=useState(formData.purchase_supplier||'');
    const [showSupplierDD,setShowSupplierDD]=useState(false);
    const [supplierPage,setSupplierPage]=useState(0);
    const [supplierSelIdx,setSupplierSelIdx]=useState(0);
    const supplierDDRef=useRef(null);

    // Medicine search
    const [medSearch,setMedSearch]=useState('');
    const [showMedDD,setShowMedDD]=useState(false);
    const [medPage,setMedPage]=useState(0);
    const [medSelIdx,setMedSelIdx]=useState(0);
    const medDDRef=useRef(null);

    // Modal reset keys — incrementing forces React to remount the component (clears form)
    const [supplierModalKey, setSupplierModalKey] = useState(0);
    const [medicineModalKey, setMedicineModalKey] = useState(0);

    const openSupplierModal = () => {
        setSupplierModalKey(k => k + 1);
        setTimeout(() => document.getElementById("erpIntSupplierBtn")?.click(), 50);
    };
    const openMedicineModal = () => {
        setMedicineModalKey(k => k + 1);
        setTimeout(() => document.getElementById("erpIntMedicineBtn")?.click(), 50);
    };

    // Clock
    useEffect(()=>{const u=()=>{const d=new Date();setCurrentTime(`${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}:${String(d.getSeconds()).padStart(2,'0')}`);};u();const t=setInterval(u,1000);return()=>clearInterval(t);},[]);
    const currentDate=(()=>{const d=new Date();return`${String(d.getDate()).padStart(2,'0')}-${String(d.getMonth()+1).padStart(2,'0')}-${d.getFullYear()}`;})();

    // Fullscreen + keyboard lock
    useEffect(()=>{
        setTimeout(()=>supplierInputRef.current?.focus(),300);
        // Inject CSS for SweetAlert + Bootstrap modal z-index in fullscreen
        const style=document.createElement('style');
        style.textContent=`.swal-on-top,.swal2-container.swal-on-top{z-index:999999!important}.modal{z-index:99999!important}.modal-backdrop{z-index:99998!important}`;
        document.head.appendChild(style);
        const enterFS=async()=>{
            try{const el=erpRef.current||document.documentElement;if(!document.fullscreenElement&&el.requestFullscreen)await el.requestFullscreen();if(navigator.keyboard&&navigator.keyboard.lock)await navigator.keyboard.lock(['Escape']);}catch(e){}
        };
        setTimeout(enterFS,100);
        const h=()=>{if(!document.fullscreenElement&&wantFS.current)setTimeout(()=>{if(wantFS.current)enterFS();},100);};
        document.addEventListener('fullscreenchange',h);
        return()=>{wantFS.current=false;document.removeEventListener('fullscreenchange',h);try{document.head.removeChild(style);}catch(e){}try{if(navigator.keyboard?.unlock)navigator.keyboard.unlock();}catch(e){}try{if(document.fullscreenElement)document.exitFullscreen();}catch(e){}};
    },[]);

    const exitAndLeave=()=>{wantFS.current=false;try{navigator.keyboard?.unlock();}catch(e){}try{if(document.fullscreenElement)document.exitFullscreen();}catch(e){}if(onSwitchToNormal)onSwitchToNormal();};

    // Sync supplier search
    useEffect(()=>{if(formData.purchase_supplier&&formData.purchase_supplier!==supplierSearch)setSupplierSearch(formData.purchase_supplier);},[formData.purchase_supplier]);

    // ── Filtered supplier list ──
    const allSuppliers=(formData.l1||[]).filter(s=>s.type==='supplier');
    const filteredSuppliers=supplierSearch.trim()?allSuppliers.filter(s=>(s.fname||'').toLowerCase().includes(supplierSearch.toLowerCase())||(s.mobile||'').includes(supplierSearch)):allSuppliers;
    const supplierPages=Math.ceil(filteredSuppliers.length/PER_PAGE);
    const supplierPageItems=filteredSuppliers.slice(supplierPage*PER_PAGE,(supplierPage+1)*PER_PAGE);

    // Close supplier dropdown on outside click
    useEffect(()=>{if(!showSupplierDD)return;const h=(e)=>{if(supplierDDRef.current&&!supplierDDRef.current.contains(e.target))setShowSupplierDD(false);};document.addEventListener('mousedown',h);return()=>document.removeEventListener('mousedown',h);},[showSupplierDD]);

    const selectSupplier=(s)=>{setFormData(prev=>({...prev,purchase_supplier:s.fname}));setSupplierSearch(s.fname);setShowSupplierDD(false);};

    const handleSupplierKeyDown=(e)=>{
        if(e.key==='F2'){e.preventDefault();openSupplierModal();return;}
        if(e.key==='Enter'){
            e.preventDefault();
            if(showSupplierDD&&supplierPageItems[supplierSelIdx]){
                selectSupplier(supplierPageItems[supplierSelIdx]);
                setTimeout(()=>invoiceRef.current?.focus(),50);
            } else if(!showSupplierDD){
                setShowSupplierDD(true);setSupplierPage(0);setSupplierSelIdx(0);
            } else if(filteredSuppliers.length===0&&supplierSearch.trim()){
                // No supplier found → ask to add
                Swal.fire({title:'Supplier Not Found',text:`"${supplierSearch}" not in list. Add new?`,icon:'question',
                    showCancelButton:true,confirmButtonText:'Add New [Enter]',cancelButtonText:'Cancel [Esc]',confirmButtonColor:C.accent
                }).then(r=>{if(r.isConfirmed)openSupplierModal();});
            }
            return;
        }
        if(e.key==='ArrowDown'){e.preventDefault();setSupplierSelIdx(p=>Math.min(p+1,supplierPageItems.length-1));}
        if(e.key==='ArrowUp'){e.preventDefault();setSupplierSelIdx(p=>Math.max(p-1,0));}
        if(e.key==='Escape'){e.preventDefault();e.stopPropagation();setShowSupplierDD(false);}
    };

    // ── Filtered medicine list ──
    const allMeds=formData.medicineList||[];
    const filteredMeds=medSearch.trim()?allMeds.filter(m=>(m.med_name||'').toLowerCase().includes(medSearch.toLowerCase())||(m.med_hsn_code||'').includes(medSearch)):allMeds;
    const medPages=Math.ceil(filteredMeds.length/PER_PAGE);
    const medPageItems=filteredMeds.slice(medPage*PER_PAGE,(medPage+1)*PER_PAGE);

    useEffect(()=>{if(!showMedDD)return;const h=(e)=>{if(medDDRef.current&&!medDDRef.current.contains(e.target))setShowMedDD(false);};document.addEventListener('mousedown',h);return()=>document.removeEventListener('mousedown',h);},[showMedDD]);
    useEffect(()=>{setMedPage(0);setMedSelIdx(0);},[medSearch]);

    const selectMedicine=(m)=>{
        setFormData(prev=>({...prev,medicines:[...prev.medicines,{
            purchase_item_medicine:m.med_name,purchase_item_medicine_id:m.med_id,
            purchase_item_hsn:m.med_hsn_code||'30049069',purchase_item_qty:'1',
            purchase_item_tab_cap:m.med_in_strips||'',purchase_item_free:'0',
            purchase_item_batch:'',purchase_item_expiry_month:'',purchase_item_expiry_year:'',
            purchase_item_pur_price:'',purchase_item_mrp:'',purchase_item_discount:'0.00',
            purchase_item_gst:m.med_gst||0,
            purchase_item_gst_value:'0.00',purchase_item_gross_value:'0.00',purchase_item_gtotal:'0.00',
        }]}));
        setMedSearch('');setShowMedDD(false);
        toast.success(`${m.med_name} added`,{autoClose:1500});
    };

    const handleMedSearchKeyDown=(e)=>{
        if(e.key==='F2'){e.preventDefault();openMedicineModal();return;}
        if(e.key==='Tab'&&!e.shiftKey){e.preventDefault();setShowMedDD(false);otherChargesRef.current?.focus();return;}
        if(e.key==='Enter'){
            e.preventDefault();
            if(showMedDD&&medPageItems[medSelIdx]){
                selectMedicine(medPageItems[medSelIdx]);
            } else if(!showMedDD){
                setShowMedDD(true);setMedPage(0);setMedSelIdx(0);
            } else if(filteredMeds.length===0&&medSearch.trim()){
                Swal.fire({title:'Medicine Not Found',text:`"${medSearch}" not in list. Add new?`,icon:'question',
                    showCancelButton:true,confirmButtonText:'Add New [Enter]',cancelButtonText:'Cancel [Esc]',confirmButtonColor:C.accent
                }).then(r=>{if(r.isConfirmed)openMedicineModal();});
            }
            return;
        }
        if(e.key==='ArrowDown'){e.preventDefault();setMedSelIdx(p=>{const n=Math.min(p+1,medPageItems.length-1);if(n>=PER_PAGE){setMedPage(pg=>Math.min(pg+1,medPages-1));return 0;}return n;});}
        if(e.key==='ArrowUp'){e.preventDefault();setMedSelIdx(p=>{if(p<=0&&medPage>0){setMedPage(pg=>pg-1);return PER_PAGE-1;}return Math.max(p-1,0);});}
        if(e.key==='Escape'){e.preventDefault();e.stopPropagation();setShowMedDD(false);}
    };

    // Header Enter nav
    const handleInvoiceEnter=(e)=>{if(e.key==='Enter'){e.preventDefault();dateRef.current?.focus();}};
    const handleDateEnter=(e)=>{if(e.key==='Enter'){e.preventDefault();challanRef.current?.focus();}};
    const handleChallanEnter=(e)=>{if(e.key==='Enter'){e.preventDefault();medSearchInputRef.current?.focus();setShowMedDD(true);setMedPage(0);setMedSelIdx(0);}};

    // Grid Enter nav
    const items=formData.medicines||[];
    const prevCount=useRef(items.length);
    useEffect(()=>{
        if(items.length>prevCount.current){
            const idx=items.length-1;setErpActiveRow(idx);setErpActiveCol(EDIT_COLS[0]);
            setTimeout(()=>{const row=rowRefs.current[idx];if(row){const el=row.querySelector(`input[name="${EDIT_COLS[0]}${idx}"]`);if(el){el.focus();el.select();}}},80);
        }
        prevCount.current=items.length;
    },[items.length]);

    const handleCellEnter=(e,rowIndex,colName)=>{
        if(e.key!=='Enter')return;e.preventDefault();e.stopPropagation();
        const ci=EDIT_COLS.indexOf(colName);
        if(ci<EDIT_COLS.length-1){
            const next=EDIT_COLS[ci+1];setErpActiveRow(rowIndex);setErpActiveCol(next);
            setTimeout(()=>{const row=rowRefs.current[rowIndex];if(row){const el=row.querySelector(`input[name="${next}${rowIndex}"]`);if(el){el.focus();el.select();}}},30);
        } else {
            setErpActiveRow(null);setErpActiveCol(null);
            setTimeout(()=>{medSearchInputRef.current?.focus();setShowMedDD(true);setMedPage(0);setMedSelIdx(0);},50);
        }
    };

    // Bottom panel Enter nav
    const handleOCEnter=(e)=>{if(e.key==='Enter'){e.preventDefault();discountRef.current?.focus();}};
    const handleDiscEnter=(e)=>{if(e.key==='Enter'){e.preventDefault();noteRef.current?.focus();}};
    const handleNoteEnter=(e)=>{if(e.key==='Enter'&&!e.shiftKey){e.preventDefault();doSave();}};
    const doSave=()=>{handleSubmit({preventDefault:()=>{}});};

    // Global shortcuts
    useEffect(()=>{
        const handler=(e)=>{
            if((e.ctrlKey||e.metaKey)&&e.key==='s'){e.preventDefault();doSave();return;}
            if(e.altKey&&(e.key==='n'||e.key==='N')){e.preventDefault();exitAndLeave();return;}
            // Global F2 - open medicine modal when not in supplier
            if(e.key==='F2'&&document.activeElement!==supplierInputRef.current){
                e.preventDefault();openMedicineModal();return;
            }
            if(e.key==='Escape'&&!showSupplierDD&&!showMedDD){
                e.preventDefault();e.stopPropagation();
                if(erpActiveCol){setErpActiveRow(null);setErpActiveCol(null);return;}
                Swal.fire({title:'Clear Form?',icon:'question',showCancelButton:true,confirmButtonText:'Clear',confirmButtonColor:'#dc2626'}).then(r=>{
                    if(r.isConfirmed){setFormData(prev=>({...prev,medicines:[],purchase_supplier:'',purchase_invoice:'',purchase_challan:'',note:'',other_charges:'0',discount_on_all_value:'0',purchase_paid:'0'}));setSupplierSearch('');setMedSearch('');toast.info('Cleared');setTimeout(()=>supplierInputRef.current?.focus(),100);}
                });
            }
        };
        document.addEventListener('keydown',handler);return()=>document.removeEventListener('keydown',handler);
    },[erpActiveCol,showSupplierDD,showMedDD]);

    // ── Bootstrap modal cleanup (fullscreen leaves residue) ──
    const cleanupBootstrapModal = () => {
        document.body.classList.remove('modal-open');
        document.body.style.removeProperty('overflow');
        document.body.style.removeProperty('padding-right');
        document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
        // Re-enable pointer events on fullscreen container
        if (erpRef.current) erpRef.current.style.pointerEvents = 'auto';
    };

    // ── Direct API reload (no closure issues) ──
    const reloadSuppliers = async () => {
        try {
            const fd = new FormData();
            fd.append('type', 'supplier');
            fd.append('search_key', '');
            fd.append('page_no', '0');
            const res = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
            if (res.data?.status && res.data.records) {
                setFormData(prev => ({ ...prev, l1: res.data.records }));
                console.log('✅ Suppliers reloaded:', res.data.records.length);
            }
        } catch (err) { console.error('Supplier reload error:', err); }
    };

    const reloadMedicines = async () => {
        try {
            const fd = new FormData();
            fd.append('page_no', '0');
            fd.append('search_key', '');
            const res = await axios.post(AppConst.BASE_URL + AppConst.getMedListUrl, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
            if (res.data?.status && res.data.records) {
                setFormData(prev => ({ ...prev, medicineList: res.data.records }));
                console.log('✅ Medicines reloaded:', res.data.records.length);
            }
        } catch (err) { console.error('Medicine reload error:', err); }
    };

    // Listen for Bootstrap modal hidden events → cleanup + reload + re-focus
    useEffect(() => {
        const handler = (e) => {
            setTimeout(() => {
                cleanupBootstrapModal();
                const modalId = e.target?.id || '';
                if (modalId === 'showModal' || modalId.includes('supplier') || modalId.includes('Supplier')) {
                    reloadSuppliers();
                    setTimeout(() => supplierInputRef.current?.focus(), 300);
                } else {
                    reloadMedicines();
                    setTimeout(() => medSearchInputRef.current?.focus(), 300);
                }
            }, 300);
        };
        document.addEventListener('hidden.bs.modal', handler);
        return () => document.removeEventListener('hidden.bs.modal', handler);
    }, []);

    // Wrapped callbacks for modal save buttons
    const wrappedAddDepart = (data) => {
        cleanupBootstrapModal();
        // Also call parent callback if provided
        if (handleAddDepart) try { handleAddDepart(data); } catch(e) {}
        // Direct reload after delay
        setTimeout(reloadSuppliers, 500);
        setTimeout(() => { cleanupBootstrapModal(); supplierInputRef.current?.focus(); }, 800);
    };
    const wrappedAddMedicine = (data) => {
        cleanupBootstrapModal();
        // Also call parent callback if provided
        if (handleAddMedicine) try { handleAddMedicine(data); } catch(e) {}
        // Direct reload after delay
        setTimeout(reloadMedicines, 500);
        setTimeout(() => { cleanupBootstrapModal(); medSearchInputRef.current?.focus(); }, 800);
    };

    // Styles
    const inputSt=(f)=>({background:C.inputBg,border:`1.5px solid ${f?C.inputFocus:C.inputBorder}`,color:C.cellText,padding:'6px 10px',borderRadius:6,fontSize:13,fontFamily:'inherit',outline:'none',width:'100%',boxShadow:f?`0 0 0 3px ${C.accentGlow}`:'none'});
    const lblSt={color:C.statusText,fontSize:11,fontWeight:600,letterSpacing:0.5,marginBottom:3,display:'block',textTransform:'uppercase'};
    const totalQty=items.reduce((s,i)=>s+(parseFloat(i.purchase_item_qty)||0)+(parseFloat(i.purchase_item_free)||0),0);

    // Dropdown renderer
    const renderDropdown=(list,pages,page,setPage,selIdx,setSelIdx,onSelect,emptyMsg,ref)=>(
        <div ref={ref} style={{position:'absolute',top:'100%',left:0,right:0,zIndex:1050,background:'#fff',border:`1.5px solid ${C.accent}`,borderRadius:6,boxShadow:'0 6px 20px rgba(0,0,0,0.12)',marginTop:2,overflow:'hidden'}}>
            {list.length>0&&<div style={{padding:'5px 10px',background:C.gridHdr,fontSize:10,color:C.accent,fontWeight:600,borderBottom:`1px solid ${C.gridBorder}`,display:'flex',justifyContent:'space-between'}}><span>{list.length} result{list.length!==1?'s':''}</span>{pages>1&&<span style={{color:C.statusText}}>Page {page+1}/{pages}</span>}</div>}
            <div style={{maxHeight:260,overflowY:'auto'}}>
                {list.length>0?list.map((item,i)=>(
                    <div key={i} onMouseDown={(e)=>{e.preventDefault();onSelect(item);}}
                        style={{padding:'8px 12px',cursor:'pointer',fontSize:13,borderBottom:`1px solid ${C.gridBorder}`,background:i===selIdx?C.rowActive:'#fff',borderLeft:i===selIdx?`3px solid ${C.accent}`:'3px solid transparent',fontWeight:i===selIdx?600:400,color:C.cellText}}
                        onMouseEnter={()=>setSelIdx(i)}>
                        {item._label||item.fname||item.med_name}
                    </div>
                )):<div style={{padding:'16px',textAlign:'center',color:C.statusText,fontSize:13}}>{emptyMsg}<br/><small style={{color:C.accent}}>Press F2 to add new</small></div>}
            </div>
            {pages>1&&(
                <div style={{padding:'5px 10px',background:C.gridHdr,borderTop:`1px solid ${C.gridBorder}`,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                    <button type="button" disabled={page===0} onMouseDown={(e)=>{e.preventDefault();setPage(p=>Math.max(0,p-1));setSelIdx(0);}}
                        style={{...btnSt(C.accent),padding:'2px 10px',fontSize:11,opacity:page===0?0.4:1}}>◀ Prev</button>
                    <span style={{fontSize:10,color:C.statusText}}>{page*PER_PAGE+1}–{Math.min((page+1)*PER_PAGE,list.length)} of {list.length}</span>
                    <button type="button" disabled={page>=pages-1} onMouseDown={(e)=>{e.preventDefault();setPage(p=>Math.min(pages-1,p+1));setSelIdx(0);}}
                        style={{...btnSt(C.accent),padding:'2px 10px',fontSize:11,opacity:page>=pages-1?0.4:1}}>Next ▶</button>
                </div>
            )}
        </div>
    );

    return(
        <div ref={erpRef} style={{position:'fixed',inset:0,zIndex:9998,background:C.bg,overflow:'hidden',fontFamily:"'Segoe UI','Inter',system-ui,sans-serif",display:'flex',flexDirection:'column'}}>
            {/* TITLE */}
            <div style={{background:'#fff',padding:'8px 20px',display:'flex',alignItems:'center',justifyContent:'space-between',borderBottom:`2px solid ${C.gridBorder}`,boxShadow:'0 1px 4px rgba(0,0,0,0.06)',flexShrink:0}}>
                <div style={{display:'flex',alignItems:'center',gap:12}}>
                    <span style={{background:C.titleBg,color:'#fff',padding:'4px 16px',borderRadius:6,fontSize:13,fontWeight:700,letterSpacing:1}}>⚡ ERP PURCHASE</span>
                </div>
                <div style={{display:'flex',alignItems:'center',gap:14,fontSize:12}}>
                    <span style={{color:C.accent,fontWeight:600}}>{currentDate}</span>
                    <span style={{color:C.statusText}}>{currentTime}</span>
                    <span style={{color:C.statusText,fontSize:10,background:'#f0f2f8',padding:'2px 8px',borderRadius:4}}>Alt+N: Exit | Ctrl+S: Save | F2: Add New | Esc: Clear</span>
                    <button type="button" onClick={exitAndLeave} style={{background:'#ef4444',border:'none',color:'#fff',width:28,height:28,borderRadius:6,cursor:'pointer',fontSize:14,fontWeight:700}} title="Back">✕</button>
                </div>
            </div>

            {/* HEADER FIELDS */}
            <div style={{background:'#fff',padding:'12px 20px',borderBottom:`1px solid ${C.gridBorder}`,flexShrink:0}}>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr 1fr',gap:12}}>
                    {/* Supplier */}
                    <div style={{position:'relative'}} ref={supplierDDRef}>
                        <label style={lblSt}>Supplier * <small style={{color:C.accent,fontWeight:400}}>[F2: Add New]</small></label>
                        <input ref={supplierInputRef} type="text" placeholder="Search supplier..."
                            value={supplierSearch} onChange={(e)=>{setSupplierSearch(e.target.value);setShowSupplierDD(true);setSupplierPage(0);setSupplierSelIdx(0);setFormData(prev=>({...prev,purchase_supplier:e.target.value}));}}
                            onFocus={()=>setShowSupplierDD(true)} onKeyDown={handleSupplierKeyDown}
                            style={inputSt(showSupplierDD)} autoComplete="off" />
                        {showSupplierDD&&renderDropdown(
                            supplierPageItems.map(s=>({...s,_label:`${s.fname} (${s.mobile||''})`})),
                            supplierPages,supplierPage,setSupplierPage,supplierSelIdx,setSupplierSelIdx,
                            (s)=>{selectSupplier(s);setTimeout(()=>invoiceRef.current?.focus(),50);},
                            'No supplier found',null
                        )}
                    </div>
                    {/* Invoice */}
                    <div><label style={lblSt}>Invoice *</label>
                        <input ref={invoiceRef} type="text" name="purchase_invoice" value={formData.purchase_invoice} onChange={handleChange} onKeyDown={handleInvoiceEnter} style={inputSt(false)} placeholder="Invoice No" /></div>
                    {/* Date */}
                    <div><label style={lblSt}>Date *</label>
                        <input ref={dateRef} type="date" name="purchase_date" value={formData.purchase_date} onChange={handleChange} onKeyDown={handleDateEnter} style={inputSt(false)} readOnly={!!formData.purchase_id} /></div>
                    {/* Challan */}
                    <div><label style={lblSt}>Bill / Challan No</label>
                        <input ref={challanRef} type="text" name="purchase_challan" value={formData.purchase_challan} onChange={handleChange} onKeyDown={handleChallanEnter} style={inputSt(false)} placeholder="Challan No → Enter for medicines" /></div>
                </div>
            </div>

            {/* MEDICINE SEARCH */}
            <div style={{padding:'8px 20px',background:'#fff',borderBottom:`1px solid ${C.gridBorder}`,flexShrink:0,position:'relative'}} ref={medDDRef}>
                <div style={{display:'flex',alignItems:'center',gap:8}}>
                    <span style={{color:C.accent,fontSize:18,width:28,textAlign:'center'}}>⌕</span>
                    <input ref={medSearchInputRef} type="text" placeholder="Search medicine / HSN... [F2: Add New]"
                        value={medSearch} onChange={(e)=>{setMedSearch(e.target.value);setShowMedDD(true);setMedPage(0);setMedSelIdx(0);}}
                        onFocus={()=>{setShowMedDD(true);setMedPage(0);setMedSelIdx(0);}}
                        onKeyDown={handleMedSearchKeyDown}
                        style={{...inputSt(showMedDD),flex:1,fontSize:14,padding:'8px 12px'}} autoComplete="off" />
                    <span style={{color:C.statusText,fontSize:10,whiteSpace:'nowrap'}}>[↑↓] Nav [Enter] Select [Tab] → Charges [F2] Add</span>
                </div>
                {showMedDD&&renderDropdown(
                    medPageItems.map(m=>({...m,_label:`HSN-${m.med_hsn_code||'—'} | ${m.med_name}`})),
                    medPages,medPage,setMedPage,medSelIdx,setMedSelIdx,
                    selectMedicine,'No medicine found',null
                )}
            </div>

            {/* GRID */}
            <div style={{flex:1,overflowY:'auto',overflowX:'auto',padding:'0 20px'}}>
                <table style={{width:'100%',borderCollapse:'collapse',fontSize:12,minWidth:1300}}>
                    <thead><tr style={{background:C.gridHdr,borderBottom:`2px solid ${C.accent}`,position:'sticky',top:0,zIndex:2}}>
                        {['#','Medicine','HSN','Qty','Strips','Free','Batch','MM','YY','P.Rate','MRP','Disc%','GST%','Tax','Gross','Total',''].map((h,i)=>(
                            <th key={i} style={{padding:'8px 5px',color:C.gridHdrText,fontSize:10,fontWeight:700,letterSpacing:0.5,textAlign:i>=9?'right':'left',whiteSpace:'nowrap',background:C.gridHdr}}>{h}</th>
                        ))}
                    </tr></thead>
                    <tbody>
                        {items.length===0&&<tr><td colSpan="17" style={{textAlign:'center',padding:'40px',color:C.statusText,background:'#fff'}}>No items — search above to add</td></tr>}
                        {items.map((item,index)=>{
                            const isRA=erpActiveRow===index;
                            const makeCell=(col,w,ro,ph)=>{
                                const isAct=isRA&&erpActiveCol===col;const val=item[col]||'';
                                return(
                                    <td key={col} style={{width:w,background:isAct?'#e8edff':undefined}} onClick={()=>{if(!ro){setErpActiveRow(index);setErpActiveCol(col);}}}>
                                        <input type="text" name={`${col}${index}`} value={val}
                                            onChange={ro?undefined:(e)=>handleChange1(e,index)}
                                            onKeyDown={ro?undefined:(e)=>handleCellEnter(e,index,col)}
                                            readOnly={ro||!isAct} autoFocus={isAct} placeholder={ph||''}
                                            style={{width:'100%',border:isAct?`1.5px solid ${C.accent}`:`1px solid ${ro?'#e9ecef':C.inputBorder}`,borderRadius:3,padding:'3px 4px',fontSize:12,outline:'none',textAlign:'center',background:ro?'#f0f0f0':isAct?'#f0f8ff':'#fff',color:ro?C.statusText:C.cellText,fontWeight:isAct?600:400,cursor:ro?'not-allowed':'text'}} />
                                    </td>
                                );
                            };
                            return(
                                <tr key={index} ref={el=>rowRefs.current[index]=el} style={{background:isRA?C.rowActive:index%2===0?C.rowEven:C.rowOdd,borderBottom:`1px solid ${C.gridBorder}`,borderLeft:isRA?`3px solid ${C.accent}`:'3px solid transparent'}}>
                                    <td style={{padding:'4px 5px',width:28}}><span style={{background:C.accent,color:'#fff',width:20,height:20,borderRadius:'50%',display:'inline-flex',alignItems:'center',justifyContent:'center',fontSize:10,fontWeight:700}}>{index+1}</span></td>
                                    <td style={{padding:'4px 5px',fontWeight:600,color:C.cellText,fontSize:12,maxWidth:150,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}} title={item.purchase_item_medicine}>{item.purchase_item_medicine}</td>
                                    {makeCell('purchase_item_hsn',55,true)}
                                    {makeCell('purchase_item_qty',50,false)}
                                    {makeCell('purchase_item_tab_cap',50,false)}
                                    {makeCell('purchase_item_free',45,false)}
                                    {makeCell('purchase_item_batch',75,false,'Batch')}
                                    {makeCell('purchase_item_expiry_month',40,false,'MM')}
                                    {makeCell('purchase_item_expiry_year',40,false,'YY')}
                                    {makeCell('purchase_item_pur_price',65,false,'Rate')}
                                    {makeCell('purchase_item_mrp',65,false,'MRP')}
                                    {makeCell('purchase_item_discount',50,false,'0')}
                                    {makeCell('purchase_item_gst',45,false,'0')}
                                    {makeCell('purchase_item_gst_value',55,true)}
                                    {makeCell('purchase_item_gross_value',65,true)}
                                    {makeCell('purchase_item_gtotal',70,true)}
                                    <td style={{width:28,textAlign:'center'}}><button type="button" onClick={()=>handleDeleteItem(index)} tabIndex={-1} style={{background:'none',border:'none',color:C.red,cursor:'pointer',fontSize:14,opacity:0.5,padding:0}} onMouseEnter={e=>e.currentTarget.style.opacity='1'} onMouseLeave={e=>e.currentTarget.style.opacity='0.5'}>✕</button></td>
                                </tr>
                            );
                        })}
                        {Array.from({length:Math.max(0,5-items.length)}).map((_,i)=><tr key={`e-${i}`} style={{background:(items.length+i)%2===0?C.rowEven:C.rowOdd,borderBottom:`1px solid ${C.gridBorder}`}}><td colSpan="17" style={{padding:'6px',color:'transparent'}}>&nbsp;</td></tr>)}
                    </tbody>
                </table>
            </div>

            {/* BOTTOM */}
            <div style={{background:'#fff',borderTop:`2px solid ${C.accent}`,display:'grid',gridTemplateColumns:'1fr 1fr',fontSize:12,flexShrink:0}}>
                <div style={{padding:'10px 20px',borderRight:`1px solid ${C.gridBorder}`,display:'flex',flexDirection:'column',gap:6}}>
                    <div style={{display:'flex',alignItems:'center',gap:8}}>
                        <span style={{...lblSt,marginBottom:0,width:90}}>Other Charges:</span>
                        <input ref={otherChargesRef} type="number" name="other_charges" value={formData.other_charges} onChange={handleChange} onKeyDown={handleOCEnter} style={{width:80,textAlign:'center',border:`1px solid ${C.inputBorder}`,borderRadius:4,padding:'2px 6px',fontSize:12,outline:'none'}} />
                        <span style={{color:C.statusText,margin:'0 4px'}}>|</span>
                        <span style={{...lblSt,marginBottom:0,width:70}}>Discount:</span>
                        <input ref={discountRef} type="number" name="discount_on_all_value" value={formData.discount_on_all_value} onChange={handleChange} onKeyDown={handleDiscEnter} style={{width:70,textAlign:'center',border:`1px solid ${C.inputBorder}`,borderRadius:4,padding:'2px 6px',fontSize:12,outline:'none'}} />
                        <select name="discount_on_all_type" value={formData.discount_on_all_type} onChange={handleChange} style={{border:`1px solid ${C.inputBorder}`,borderRadius:4,padding:'2px 4px',fontSize:11,outline:'none',cursor:'pointer'}}><option value="Per%">%</option><option value="Flat">₹</option></select>
                    </div>
                    <div style={{display:'flex',alignItems:'center',gap:8}}>
                        <span style={{...lblSt,marginBottom:0,width:90}}>Note:</span>
                        <input ref={noteRef} type="text" name="note" value={formData.note||''} onChange={handleChange} onKeyDown={handleNoteEnter} style={{flex:1,border:`1px solid ${C.inputBorder}`,borderRadius:4,padding:'2px 8px',fontSize:12,outline:'none'}} placeholder="Enter → Save" />
                    </div>
                    <div style={{display:'flex',alignItems:'center',gap:8}}>
                        <span style={{...lblSt,marginBottom:0,width:90}}>Paid:</span>
                        <input type="number" name="purchase_paid" value={formData.purchase_paid||''} onChange={handleChange} style={{width:90,textAlign:'center',border:`1px solid ${C.inputBorder}`,borderRadius:4,padding:'2px 6px',fontSize:12,outline:'none'}} />
                        <span style={{color:C.statusText,margin:'0 4px'}}>|</span>
                        <span style={{...lblSt,marginBottom:0}}>Due:</span>
                        <span style={{color:C.red,fontWeight:700,fontSize:13}}>₹{formData.purchase_due||'0.00'}</span>
                    </div>
                </div>
                <div style={{padding:'10px 20px'}}>
                    <div style={{display:'grid',gridTemplateColumns:'130px 1fr',gap:'2px 10px'}}>
                        <span style={{color:C.statusText,fontWeight:600,fontSize:11}}>SUBTOTAL :</span><span style={{color:C.cellText,fontSize:12,textAlign:'right',fontWeight:600}}>₹{formData.subtotal||'0.00'}</span>
                        <span style={{color:C.statusText,fontWeight:600,fontSize:11}}>OTHER CHARGES :</span><span style={{color:C.cellText,fontSize:12,textAlign:'right'}}>₹{parseFloat(formData.other_charges||0).toFixed(2)}</span>
                        <span style={{color:C.statusText,fontWeight:600,fontSize:11}}>GST :</span><span style={{color:C.cellText,fontSize:12,textAlign:'right'}}>₹{formData.total_gst||'0.00'}</span>
                        <span style={{color:C.statusText,fontWeight:600,fontSize:11}}>DISCOUNT :</span><span style={{color:C.red,fontSize:12,textAlign:'right'}}>-₹{formData.discount_on_all_amount||'0.00'}</span>
                    </div>
                    <div style={{borderTop:`1px solid ${C.gridBorder}`,marginTop:6,paddingTop:6,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                        <span style={{color:C.warnText,fontWeight:700,fontSize:15}}>GRAND TOTAL :</span>
                        <span style={{color:C.cellText,fontWeight:800,fontSize:20}}>₹{formData.grand_total||'0.00'}</span>
                    </div>
                </div>
            </div>

            {/* STATUS */}
            <div style={{background:'#fff',padding:'6px 20px',display:'flex',alignItems:'center',justifyContent:'space-between',borderTop:`1px solid ${C.gridBorder}`,fontSize:12,flexShrink:0}}>
                <div style={{display:'flex',gap:16,color:C.statusText}}>
                    <span>Items: <strong style={{color:C.accent}}>{items.length}</strong></span>
                    <span>Qty: <strong style={{color:C.green}}>{totalQty}</strong></span>
                    <span>Supplier: <strong style={{color:C.accent}}>{formData.purchase_supplier||'—'}</strong></span>
                </div>
                <div style={{display:'flex',gap:8}}>
                    <button type="button" onClick={doSave} style={{background:C.green,border:'none',color:'#fff',padding:'6px 16px',borderRadius:6,cursor:'pointer',fontSize:12,fontWeight:600}}>💾 Save [Ctrl+S]</button>
                    <button type="button" onClick={exitAndLeave} style={{background:'#6b7280',border:'none',color:'#fff',padding:'6px 16px',borderRadius:6,cursor:'pointer',fontSize:12,fontWeight:600}}>← Normal View</button>
                </div>
            </div>

            {/* ═══ HIDDEN TRIGGER BUTTONS + MODALS — INSIDE fullscreen container ═══ */}
            <button id="erpIntSupplierBtn" type="button"
                data-bs-toggle="modal" data-bs-target="#showModal"
                style={{display:'none'}} />
            <button id="erpIntMedicineBtn" type="button"
                data-bs-toggle="modal" data-bs-target="#addMedicineModal"
                style={{display:'none'}} />
            <NewSupplier key={`sup-${supplierModalKey}`} onAddDepart={wrappedAddDepart} />
            <AddMedicine key={`med-${medicineModalKey}`} onAddDepart={wrappedAddMedicine} />
        </div>
    );
}

function btnSt(bg){return{background:bg,border:'none',color:'#fff',padding:'6px 16px',borderRadius:6,cursor:'pointer',fontSize:12,fontWeight:600};}

export default ERPPurchaseView;